import React from 'react';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  IN_REQUEST_INF_TYPE_ENUM_LIST,
} from '../../../configs';

export default function InformationLogSelectProcedure(props) {
  const {
    onClose = () => {},
    onSelectProcedure = () => {},
  } = props;
  const { formatMessage } = useIntl();
  const renderButton = (item, key) => (<Button variant="secondary" key={key} className="" onClick={() => onSelectProcedure(item.value)}>{formatMessage({ id: item.nameId })}</Button>);
  return (
    <Dialog
      className="information-select-procedure-dialog"
      onClose={onClose}
      open
    >
      <DialogTitle header="Выбор сведений для подачи" title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="information-select-procedure-content">
        <div className="information-select-procedure-column mt-3">{IN_REQUEST_INF_TYPE_ENUM_LIST.map(renderButton)}</div>
      </DialogContent>
      <DialogFooter>
        <div className="hff-footer-buttons">
          <Button className="hff-clear-data" variant="secondary" onClick={onClose}>Отменить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
